import { AnimatePresence, motion } from "framer-motion";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./navMenu.css";

import Close from "../../assets/icons/close";
import { useDisableBodyScroll } from "../../hooks/useDisableBodyScroll";
import { openModal, showSignInForm, showSignUpForm, updateLogoutModalActive } from "../../redux/slices/formDetails";
import { updateIsLoggedIn } from "../../redux/slices/user";
import MenuItem from "./menuItem";

export default function NavMenu({ setNavMenuActive, navMenuActive }) {
  const dispatch = useDispatch();

  const menuRef = useRef(null);

  useDisableBodyScroll(navMenuActive);
  const { isLoggedIn } = useSelector((state) => state.user);

  // const handleLogout = () => {
  //   localStorage.removeItem("access");
  //   localStorage.removeItem("refresh");
  //   dispatch(updateIsLoggedIn(false));
  //   window.location.reload();
  // };

  const handleClick = () => {
    dispatch(openModal());
  };

  const pageVariants = {
    initial: { x: "-100vw" },
    in: { x: 0 },
    out: { x: "-100vw" },
  };

  const pageTransition = {
    type: "tween",
    ease: "anticipate",
    duration: 0.3,
  };
  useEffect(() => {
    if (!menuRef.current || !menuRef.current.style) return;
    if (navMenuActive) {
      menuRef.current.style.display = "flex";
    } else {
      setTimeout(() => {
        menuRef.current.style.display = "none";
      }, 500);
    }
  }, [navMenuActive]);

  return (
    <div ref={menuRef} className="menu_container">
      {navMenuActive && <div className="modal-overlay" onClick={() => setNavMenuActive(false)}></div>}
      {
        <AnimatePresence>
          {navMenuActive && (
            <motion.div initial="initial" animate="in" exit="out" variants={pageVariants} transition={pageTransition} className="menu_wrapper">
              <div className="menu_header">
                <div className="menu_header__title">Menu</div>
                <div onClick={() => setNavMenuActive(false)} className="close_menu_btn">
                  <Close />
                </div>
              </div>
              <div className="menu">
                <div className="menu_header__items">
                  <MenuItem setNavMenuActive={setNavMenuActive} text="Home" linkTo="/" />
                  <MenuItem setNavMenuActive={setNavMenuActive} text="Create" linkTo="./design" fill="#000" />
                  <MenuItem setNavMenuActive={setNavMenuActive} text="All Duonuts" linkTo="./allduonuts" />
                  {isLoggedIn && <MenuItem setNavMenuActive={setNavMenuActive} text="My Duonuts" linkTo="./myduonuts" />}
                  <MenuItem setNavMenuActive={setNavMenuActive} text="What are Duonuts ?" linkTo="./home" />
                  <MenuItem setNavMenuActive={setNavMenuActive} text="About Us" linkTo="./home" />
                  <MenuItem setNavMenuActive={setNavMenuActive} text="Contact Us" linkTo="./home" />
                </div>
                <div className="menu_bottom">
                  <div className="menu_buttons">
                    {!isLoggedIn ? (
                      <button
                        onClick={() => {
                          handleClick();
                          dispatch(showSignInForm());
                        }}
                        className="btn-secondary sign-in-btn"
                      >
                        Sign in
                      </button>
                    ) : (
                      <button
                        onClick={() => {
                          dispatch(updateLogoutModalActive(true));
                        }}
                        className="btn-secondary sign-in-btn"
                      >
                        Sign out
                      </button>
                    )}

                    {!isLoggedIn && (
                      <button
                        onClick={() => {
                          handleClick();
                          dispatch(showSignUpForm());
                        }}
                        className="btn-primary sign-up-btn"
                      >
                        Sign up
                      </button>
                    )}
                  </div>
                  <div className="menu_social_media_icons">
                    <img src="/assets/icons/facebook.svg" className="social-media-icon" />
                    <img src="/assets/icons/twitter.svg" className="social-media-icon" />
                    <img src="/assets/icons/whatsapp.png" className="social-media-icon" />
                    <img src="/assets/icons/mail.svg" className="social-media-icon" />
                    <img src="/assets/icons/instagram.svg" className="social-media-icon" />
                  </div>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      }
    </div>
  );
}
